"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ErrorBoundary = _interopRequireDefault(require("../ErrorBoundary"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Error Boundary mechanism that falls back to an empty `div` if any error
 * occurs while rendering any child components.
 */
class LinkPanelBoundary extends _ErrorBoundary.default {
  constructor(props) {
    super(props);
  }
  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/_react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: `<!-- ${this.props.name} could not render -->`
        }
      });
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.props.children);
  }
}
var _default = exports.default = LinkPanelBoundary;